"use client";

import { Box, Link, styled } from "@mui/material";

const BackArrow = styled("img")({
  width: "12px",
  marginRight: "8px",
});

const BackLink = styled(Link)({
  display: "flex",
  font: "var(--text-body3)",
  alignItems: "center",
  cursor: "pointer",
  color: "#000000",
  textDecoration: "underline",
  textUnderlineOffset: "4px",
  "&:hover": {
    textDecoration: "none",
  },
});

export default function BackButton({ title, onClick }) {
  return (
    <BackLink
      id="backButton"
      component="button"
      variant="body1"
      underline="hover"
      onClick={onClick}
    >
      <Box display="flex" alignItems="center">
        <BackArrow src="/img/arrow-left-solid-2x.png" alt="Back" />
        {title || "Back"}
      </Box>
    </BackLink>
  );
}